import { Form, Row } from 'antd';
import React, { useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';
import usePageName from 'hooks/usePageName';

import pozadavkyKategorieSelect from 'data/codebooks/statniSprava/pozadavkyKategorieSelect';

import isinValidation from 'utils/validations/isinValidation';

import AlertComponent from './AlertComponent';
import IsinSelect from './IsinSelect';
import IsinTable from './IsinTable';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF39 {}

const F39: React.FC<IF39> = () => {
    // page1710, page1716
    const [form] = Form.useForm();
    const pageName = usePageName();
    const [, dateLoading, commonDisabledDate] = useDateLimit();
    const [showIsinTable, setShowIsinTable] = useState<boolean>(false);

    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            ...fieldsValue,
            dtvp: fieldsValue.dtvp.format('YYYY-MM-DD')
        };
        onFormSubmit(dataToSend);
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F39" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f39ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            {showIsinTable ? (
                                <IsinTable upperForm={form} setShowIsinTable={setShowIsinTable} formIsinName={'cval'} />
                            ) : (
                                <>
                                    <LoadingWrapper loading={dateLoading}>
                                        <DatePickerComponent
                                            name="dtvp"
                                            disabled={currentStep > 0}
                                            label="ME_POZADAVKY_DATUM1_POZADOVANE"
                                            disabledDate={current => commonDisabledDate(current)}
                                        />
                                    </LoadingWrapper>
                                    {pageName === 'page1716' ? (
                                        <>
                                            <InputComponent
                                                disabled={currentStep > 0}
                                                label="ISIN"
                                                name="cval"
                                                type="text"
                                                maxLength={12}
                                                rules={isinValidation()}
                                                capitalize={true}
                                            />
                                            {currentStep === 0 && (
                                                <ButtonComponent
                                                    id="f39IsinBtn"
                                                    buttontext="DUVERNE_INFO_ISIN_BUTTON"
                                                    onClick={() => setShowIsinTable(true)}
                                                    style={{
                                                        position: 'relative',
                                                        top: -12
                                                    }}
                                                />
                                            )}
                                        </>
                                    ) : (
                                        <IsinSelect disabled={currentStep > 0} />
                                    )}
                                    <SelectComponent
                                        disabled={currentStep > 0}
                                        name="pdcp"
                                        labelParagraph="ME_POZADAVKY_KATEGORIE"
                                        labelCol={{
                                            span: 8
                                        }}
                                        defaultValue={pozadavkyKategorieSelect[0].value}
                                        data={pozadavkyKategorieSelect}
                                        isFormItem={true}
                                    />
                                    {currentStep === 0 && (
                                        <ButtonComponent
                                            id="f39OdeslatBtn"
                                            buttontext="ODESLAT"
                                            onClick={() => form.submit()}
                                        />
                                    )}
                                    {currentStep !== 0 && upozorneni && (
                                        <AlertComponent
                                            upozorneni={upozorneni}
                                            type={currentStep === 1 ? 'error' : 'info'}
                                        />
                                    )}
                                    {currentStep === 1 && (
                                        <Row className="button-row">
                                            <ButtonComponent
                                                id="f39ZpetAltBtn"
                                                buttontext="ZPET"
                                                onClick={() => prev()}
                                                type="default"
                                            />
                                            <ButtonComponent
                                                id="f39PotvrditBtn"
                                                buttontext="POTVRDIT"
                                                onClick={() => form.submit()}
                                            />
                                        </Row>
                                    )}
                                </>
                            )}
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}{' '}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F39;
